import React from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as FlashCodeIcon2 } from '../../Icons/flashcode-icon_2.svg';
import LandingNav from './LandingNav';

const LandingHeader = ({ scrollToSection, featuresRef, useCasesRef, faqRef }) => (
  <header className="landing-page-header">
    <div className="landing-page-header-container">
      <div className="landing-page-logo-container">
        <FlashCodeIcon2 className="landing-page-flash-icon" />
        <h3 className='landing-page-title'>Flash Code</h3>
      </div>
      <LandingNav
        scrollToSection={scrollToSection}
        featuresRef={featuresRef}
        useCasesRef={useCasesRef}
        faqRef={faqRef}
      />
      <div className="landing-page-auth-container">
        <Link to="/auth?from=landing" className="landing-page-login-button">Log In</Link>
        <Link to="/auth?mode=signup&from=landing" className="landing-page-signup-button">Sign Up</Link>
      </div>
    </div>
  </header>
);

export default LandingHeader; 